export default {
      id: "map-pin-dark-usage",
      viewBox: "0 0 11.189 15.973",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#map-pin-dark",
      toString: function () {
        return this.url;
      }
    }